import { AlertProps, SvgIcon } from '@mui/material';
import { ReactComponent as AlertIcon } from 'assets/icons/alert-icon.svg';
import React, { memo } from 'react';

import { StyledErrorAlert } from './Alert.styled';

const ErrorAlert: React.FC<Omit<AlertProps, 'severity' | 'square'>> = memo(props => {
  const icon = <SvgIcon component={AlertIcon} inheritViewBox data-testid="alert-icon" />;

  return (
    <StyledErrorAlert {...props} severity="error" icon={icon}>
      {props.children}
    </StyledErrorAlert>
  );
});

export default ErrorAlert;
